import { ResourceType } from '../types/resource';
export function getUserType({ type }) {
    return type === 'super group' ? 'super' : type;
}
/** Returns true if (gr)user is a group */ export function isGroup(user) {
    return user && Boolean(user.type.includes('group'));
}
/** Returns group or user type id based on given gruser */ export function getUserTypeId(user) {
    return isGroup(user) ? ResourceType.GROUP : ResourceType.USER;
}
export function getUserAvatarSrc(user) {
    if (!user) {
        return null;
    }
    if (isGroup(user)) {
        return user.usericon;
    }
    if (user.usericonDefault || !user.usericon) {
        return null;
    }
    return user.usericon;
}
